import { useState } from 'react';

import Btn from '@components/Btn';
import style from '../index.module.scss';
import Prompt from '@components/Prompt';
import { HOME_TITLE } from '@lib/constants';

export default function ProspectusLite() {
	const [showCopiedToClipBoard, setShowCopiedToClipBoard] = useState(false);

	const nativeShareAPI = (e) => {
		const shareData = {
			title: HOME_TITLE,
			url: window.location.href,
		};

		try {
			if (navigator.share && navigator.canShare(shareData)) {
				navigator.share(shareData);
			} else {
				navigator.clipboard.writeText(shareData.url);
				setShowCopiedToClipBoard(true);
			}
		} catch (err) {
			console.log(err);
		}
	};

	const hidePrompt = (e) => {
		setShowCopiedToClipBoard(false);
	};

	return (
		<div className={`masthead__right ${style.menuRight}`}>
			<Btn onClick={nativeShareAPI} customClass={['primary', 'mb-0', style.widthAuto]}>
				Share
			</Btn>
			{showCopiedToClipBoard && (
				<Prompt text={'Copied to clipboard'} id="copiedToClipboard" hidePrompt={hidePrompt} />
			)}
		</div>
	);
}
